var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "product-search" }, [
    _c("div", { staticClass: "product-filters" }, [
      _c("div", { staticClass: "product-filter" }, [
        _c(
          "button",
          {
            staticClass: "product-filter__button",
            class: { "product-filter__button--active": _vm.categoryOpen },
            attrs: { disabled: !_vm.categoryItemsFound },
            on: {
              click: function($event) {
                return _vm.toggleCategory()
              }
            }
          },
          [
            _c("span", { staticClass: "product-filter__button__selection" }, [
              _vm._v("\n          " + _vm._s(_vm.selectedTitle) + "\n        ")
            ])
          ]
        ),
        _vm._v(" "),
        _vm.categoryOpen
          ? _c("div", { staticClass: "product-filter__dropdown" }, [
              _c("div", { staticClass: "product-filter__dropdown-section" }, [
                _c(
                  "ul",
                  { staticClass: "product-filter__options" },
                  [
                    _c("li", { staticClass: "product-filter__option" }, [
                      _c(
                        "label",
                        { staticClass: "product-filter__selection" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedCategory,
                                expression: "selectedCategory"
                              }
                            ],
                            staticClass: "product-filter__option__input",
                            attrs: { type: "radio" },
                            domProps: {
                              value: false,
                              checked: _vm._q(_vm.selectedCategory, false)
                            },
                            on: {
                              change: [
                                function($event) {
                                  _vm.selectedCategory = false
                                },
                                function($event) {
                                  return _vm.selectCategory()
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "product-filter__option__value product-filter__option__value--radio"
                            },
                            [_vm._v(_vm._s(_vm.mainCategory.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "product-filter__option__count" },
                            [_vm._v(_vm._s(_vm.mainCategory.count))]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.categories, function(category, index) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: category.count > 0,
                              expression: "category.count > 0"
                            }
                          ],
                          key: index,
                          staticClass: "product-filter__option"
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "product-filter__selection" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedCategory,
                                    expression: "selectedCategory"
                                  }
                                ],
                                staticClass: "product-filter__option__input",
                                attrs: { type: "radio" },
                                domProps: {
                                  value: category.slug,
                                  checked: _vm._q(
                                    _vm.selectedCategory,
                                    category.slug
                                  )
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      _vm.selectedCategory = category.slug
                                    },
                                    function($event) {
                                      return _vm.selectCategory()
                                    }
                                  ],
                                  click: function($event) {
                                    return _vm.toggleCategory()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "product-filter__option__value product-filter__option__value--radio"
                                },
                                [_vm._v(_vm._s(category.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "product-filter__option__count"
                                },
                                [_vm._v(_vm._s(category.count))]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-filter" },
        [
          _c("ProductFilters", {
            ref: "filters",
            attrs: {
              "fixed-brand": _vm.fixedBrand,
              "price-range-interval": _vm.priceRangeInterval
            },
            on: {
              toggle: _vm.updateFilterToggleStatus,
              "filters-changed": _vm.filtersChanged
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-filter" }, [
        _c(
          "button",
          {
            staticClass: "product-filter__button",
            class: { "product-filter__button--active": _vm.sortOrderOpen },
            on: {
              click: function($event) {
                return _vm.toggleOrder()
              }
            }
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$modeoL10n.order_verb) + "\n        "
            ),
            _vm.sortOrder.orderBy !== "default"
              ? _c("span", { staticClass: "product-filter__button__value" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.sortOrder.label) + "\n        "
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.sortOrderOpen
          ? _c("div", { staticClass: "product-filter__dropdown" }, [
              _c("div", { staticClass: "product-filter__dropdown-section" }, [
                _c(
                  "ul",
                  { staticClass: "product-filter__options" },
                  _vm._l(_vm.sortOrderOptions, function(
                    sortOrderOption,
                    index
                  ) {
                    return _c(
                      "li",
                      { key: index, staticClass: "product-filter__option" },
                      [
                        _c(
                          "label",
                          { staticClass: "product-filter__selection" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sortOrder,
                                  expression: "sortOrder"
                                }
                              ],
                              staticClass: "product-filter__option__input",
                              attrs: { type: "radio" },
                              domProps: {
                                value: sortOrderOption,
                                checked: _vm._q(_vm.sortOrder, sortOrderOption)
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.sortOrder = sortOrderOption
                                  },
                                  function($event) {
                                    return _vm.selectOrder()
                                  }
                                ],
                                click: function($event) {
                                  return _vm.toggleOrder()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "product-filter__option__value product-filter__option__value--radio"
                              },
                              [_vm._v(_vm._s(sortOrderOption.label))]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "product-search__results",
        class: { "product-search__results--inactive": _vm.dropdownsOpen },
        on: {
          click: function($event) {
            return _vm.closeAllFilters()
          }
        }
      },
      [
        _c("div", { staticClass: "product-search__details" }, [
          !_vm.fixedOutlet
            ? _c("div", { staticClass: "product-special-filters" }, [
                _vm.productsOnSaleCount > 0
                  ? _c("label", { staticClass: "product-special-filter" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.sale,
                            expression: "filters.sale"
                          }
                        ],
                        staticClass: "checkbox-input",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.filters.sale)
                            ? _vm._i(_vm.filters.sale, null) > -1
                            : _vm.filters.sale
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.filters.sale,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "sale",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "sale",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filters, "sale", $$c)
                              }
                            },
                            function($event) {
                              return _vm.selectSaleFilter()
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "product-special-filter__label checkbox-label"
                        },
                        [_vm._v(_vm._s(_vm.$modeoL10n.sale))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "product-special-filter__count" },
                        [_vm._v(_vm._s(_vm.productsOnSaleCount))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.productsOnStockCount > 0
                  ? _c("label", { staticClass: "product-special-filter" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.stock,
                            expression: "filters.stock"
                          }
                        ],
                        staticClass: "checkbox-input",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.filters.stock)
                            ? _vm._i(_vm.filters.stock, null) > -1
                            : _vm.filters.stock
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.filters.stock,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "stock",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "stock",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filters, "stock", $$c)
                              }
                            },
                            function($event) {
                              return _vm.selectInStockFilter()
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "product-special-filter__label checkbox-label"
                        },
                        [_vm._v(_vm._s(_vm.$modeoL10n.in_stock))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "product-special-filter__count" },
                        [_vm._v(_vm._s(_vm.productsOnStockCount))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.productsOnShowroomCount > 0 && !_vm.fixedShowroom
                  ? _c("label", { staticClass: "product-special-filter" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.showroom,
                            expression: "filters.showroom"
                          }
                        ],
                        staticClass: "checkbox-input",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.filters.showroom)
                            ? _vm._i(_vm.filters.showroom, null) > -1
                            : _vm.filters.showroom
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.filters.showroom,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "showroom",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "showroom",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filters, "showroom", $$c)
                              }
                            },
                            function($event) {
                              return _vm.selectShowroomFilter()
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "product-special-filter__label checkbox-label"
                        },
                        [_vm._v(_vm._s(_vm.$modeoL10n.in_showroom))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "product-special-filter__count" },
                        [_vm._v(_vm._s(_vm.productsOnShowroomCount))]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "product-search__count" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("formatString")(
                    _vm.productCount == 1
                      ? _vm.$modeoL10n.one_product_in_total
                      : _vm.$modeoL10n.x_products_in_total,
                    _vm.productCount
                  )
                ) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "product-list" },
          [
            _vm._l(_vm.products, function(product) {
              return _c(
                "div",
                { key: product.id, staticClass: "product-list__item" },
                [
                  _c("ProductTeaser", {
                    key: product.id,
                    attrs: { product: product, type: "grid" }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.loading
              ? _vm._l(_vm.resultsPerPage, function(n) {
                  return _c(
                    "div",
                    { key: n, staticClass: "product-list__item" },
                    [_c("ProductContentLoader")],
                    1
                  )
                })
              : _vm._e()
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _vm.currentPage < _vm.totalPages
      ? _c("div", { staticClass: "product-search__footer" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn--block-small btn--secondary btn--secondary-more",
              attrs: { disabled: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.loadMore()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.$modeoL10n.show_more) + "\n    ")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ec983de", { render: render, staticRenderFns: staticRenderFns })
  }
}